<template>
  <div class="card mb-3">
    <div class="card-body d-flex align-items-start gap-3">
      <div class="notice-icon">
        <i class="fa-solid fa-building-columns"></i>
      </div>
      <div class="flex-grow-1">
        <h6 class="mb-1">Conta Stripe Connect pendente</h6>
        <p class="text-muted mb-2">
          O psicólogo precisa ter uma conta Stripe Connect para poder
          realizar sessões e receber repasses financeiros.
        </p>
        <p class="text-muted mb-2">
          <strong>Copie o link abaixo e envie para o psicólogo</strong>
          para que ele complete o cadastro.
        </p>
        <div class="input-group input-group-sm" style="max-width: 420px">
          <input
            type="text"
            class="form-control"
            ref="linkInput"
            :value="signupLink"
            readonly
            @click="$event.target.select()"
          />
          <button
            type="button"
            class="btn btn-outline-primary"
            title="Copiar link"
            @click="copyLink"
          >
            <i class="fa-solid fa-copy"></i>
          </button>
          <a
            :href="signupLink"
            target="_blank"
            class="btn btn-outline-secondary"
            title="Abrir link"
          >
            <i class="fa-solid fa-arrow-up-right-from-square"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PsiDetailStripeConnectNotice",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    signupLink() {
      const base =
        this.$appEnv == "prod"
          ? "https://api.psiapp.com.br/stripe-connect"
          : "https://api-dev.psiapp.com.br/stripe-connect";
      return `${base}/${this.item.id}`;
    },
  },
  methods: {
    copyLink() {
      const input = this.$refs.linkInput;
      input.focus();
      input.select();

      let copied = false;
      try {
        copied = document.execCommand("copy");
      } catch (e) {
        copied = false;
      }

      if (copied) {
        this.$eventBus.$emit("showToast", {
          title: "Copiado",
          msg: "Link copiado para a área de transferência.",
        });
        return;
      }

      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.signupLink).then(
          () => {
            this.$eventBus.$emit("showToast", {
              title: "Copiado",
              msg: "Link copiado para a área de transferência.",
            });
          },
          () => {
            this.$eventBus.$emit("showToast", {
              title: "Não foi possível copiar automaticamente",
              msg: "O link já está selecionado — use Ctrl/Cmd+C.",
            });
          }
        );
      }
    },
  },
};
</script>

<style scoped>
.notice-icon {
  flex: 0 0 auto;
  width: 46px;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 1.15rem;
  background-color: #eef1f6;
  color: #8896a6;
}
</style>
